import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CompanyPageStepLicenseAssessmentsComponent } from './company-page-step-license-assessments.component';

@NgModule({
  declarations: [CompanyPageStepLicenseAssessmentsComponent],
  imports: [CommonModule, FormsModule],
  exports: [CompanyPageStepLicenseAssessmentsComponent],
  entryComponents: [CompanyPageStepLicenseAssessmentsComponent]
})
export class CompanyPageStepLicenseAssessmentsModule { }
